<template>
  <article :class="getClassName('cart')">
    <h1 :class="getClassName('cart__title')">ショッピングカート</h1>
    <div :class="getClassName('cart__items')" v-if="items.length > 0">
      <Item
        v-for="(value, index) in items"
        :key="value.id"
        :media="media"
        :index="index"
        v-model="items[index]"
        @remove="remove"
        @alert="applyAlert"
      />
    </div>
    <div :class="getClassName('cart__empty')" v-else>ショッピングカートに商品がありません</div>

    <Footer :items="items" :order-url="orderUrl" :media="media" />

    <Alert
      :visible="alert.visible"
      :varient="alert.varient"
      :messages="alert.messages"
      :media="media"
      @hide="alert.visible = false"
    />

    <Loading :is-show="isLoading" />
  </article>
</template>

<script>
import axios from 'axios';
import { APP_URL, API_URL } from '../../config/const';
import { OK, CREATED, UNPROCESSABLE_ENTITY, ERROR_MESSAGES, numberFormat } from '../../_modules/util';

import getClassName from '../_mixins/getClassName';
import mediaQuery from '../_mixins/mediaQuery';

import Alert from '../_components/Alert';
import Loading from '../_components/Loading';
import Item from './components/Item';
import Footer from './components/Footer';

export default {
  mixins: [getClassName, mediaQuery],
  components: {
    Item,
    Footer,
    Alert,
    Loading,
  },
  data() {
    return {
      items: [],
      orderUrl: '',
      alert: {
        visible: false,
        varient: '',
        messages: [],
      },
      isLoading: false,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.isLoading = true;
      const response = await axios.get(API_URL + '/cart');
      if (response.status === OK) {
        this.items = response.data.items;
        this.orderUrl = response.data.order_url;
        this.isLoading = false;
        return false;
      }

      this.alert = {
        visible: true,
        varient: 'error',
        messages: [ERROR_MESSAGES[response.status]],
      };
      this.isLoading = false;
    },
    applyAlert(alert) {
      this.alert = { ...alert, visible: true };
    },
    remove(id) {
      this.items = this.items.filter((value) => value.id !== id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_sass/variables';
@import '../_sass/mixins';

.cart {
  width: 1000px;
  padding-top: 50px;
  margin: 0 auto;
  &--sp {
    width: 93.75%;
    padding-top: 0;
  }
  &__title {
    padding-bottom: 14px;
    border-bottom: solid 1px currentcolor;
    @include title;
    font-size: 1.7rem;
    line-height: 25px;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      background: url(./images/icon_cart.png) no-repeat center center;
      background-size: cover;
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
    &--sp {
      font-size: 1.6rem;
      &::before {
        margin-right: 7px;
      }
    }
  }
  &__items {
    margin-top: 10px;
    &--sp {
      margin-top: 0px;
    }
  }
  &__empty {
    height: 720px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    &--sp {
      height: 400px;
    }
  }
}
</style>
